
import RugbyHeader from '../components/header/rugby-header'


import './rugby-stats.css'

const RugbyStats = () => {
    return (
        <>
            <RugbyHeader />
            <div className="stats">
                <div className="stats-container">
                    <div className="stats-box"></div>
                </div>
            </div>
        </>

    );
}


export default RugbyStats;